// @ts-nocheck

import React from 'react';
import PropTypes from 'prop-types';
import {  Drawer, Form, Button, Switch, Input } from 'antd';
import { RegexInput } from 'shared_components/pattern_input';
import { FIELD_RULES } from './constants';
import ModuleForm from './module_form';
import useFormDrawerHook from './form_drawer_hook';
import './style.css';
import errorMessage from 'global_config/error_messages';

const { TextArea } = Input;

function FormDrawer({ onClose, visible, id = null, modules, onSuccess }) {
  const actionType = id ? 'UPDATE' : 'ADD';
  const { onSubmit, formRef } = useFormDrawerHook(id, modules, onSuccess, visible);
  const switchAttributes = (() =>{
    if(id === null){   
      return({
        defaultChecked: true
      });
    }
  })();

  return (
    <Drawer
      title={`${actionType} USER TYPE`}
      width="30%"
      placement="right"
      closable
      onClose={onClose}
      open={visible}
      destroyOnClose
    >
      <Form 
        className="settings-user-right-drawer-form"
        onFinish={onSubmit}
        layout="vertical"
        ref={formRef}
        style={{paddingBottom:40}}
      >
        <section>
          <Form.Item name={'active'}
            valuePropName={'checked'}
            label={'STATUS'}
            initialValue={id === null ? true : undefined}
            >
            <Switch {...switchAttributes} disabled={id === null} />
          </Form.Item>
          <Form.Item
            name="userType"
            label="USER TYPE"
            // rules={FIELD_RULES.userType}
            rules={[
              { required: true, message: errorMessage.required },
            ]}
          >
            <Input
              maxLength={50}
            />
          </Form.Item>  
          <Form.Item
            name="typeDescription"
            label="DESCRIPTION"
            // rules={FIELD_RULES.description}
          >
            {/* <RegexInput
              regex={/[A-Za-z0-9 -]/}
              maxLength={200}
            /> */}
            <TextArea maxLength={254} />
          </Form.Item>

          {/* Hidden validation field for module permissions */}
          <Form.Item
            name="modulePermissionValidator"
            style={{ marginTop: -30 }}
            rules={[
              {
                validator: (_, value) => {
                  const formValues = formRef.current.getFieldsValue();
                  const hasAnyPermission = modules.some(module => {
                    return formValues[`${module.moduleName}-view`] ||
                           formValues[`${module.moduleName}-create`] ||
                           formValues[`${module.moduleName}-edit`] ||
                           formValues[`${module.moduleName}-print`];
                  });

                  if (!hasAnyPermission) {
                    return Promise.reject(new Error('At least one module permission is required'));
                  }
                  return Promise.resolve();
                }
              }
            ]}
          >
            <input type="hidden" />
          </Form.Item>

          <ModuleForm initialModules={modules}/>
        </section>
        <section className="drawerFooter">
          <div>
            <Button 
              shape="round" 
              style={{ margin: 10, width: 120 }}
              onClick={onClose}
            >
              CANCEL
            </Button>
            <Button 
              shape="round" 
              type="primary" 
              htmlType="submit"
              loading={false}
              style={{ margin: 10, width: 120 }}
            >
              {actionType}
            </Button>
          </div>
        </section>
      </Form> 
    </Drawer>
  );
}

FormDrawer.propTypes = {
  id: PropTypes.number,
	onClose: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
  modules: PropTypes.array,
  onSuccess: PropTypes.func
};


export default FormDrawer;